import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from "@angular/forms";

@Component({
  selector: "app-maintenance-type",
  templateUrl: "./maintenance-type.component.html",
  styleUrls: ["./maintenance-type.component.css"],
})
export class MaintenanceTypeComponent implements OnInit {
  constructor(private formBuilder: FormBuilder) {}

  @Output() maintenanceTypeEvent = new EventEmitter<any>();

  ngOnInit() {}

  maintenanceType = this.formBuilder.group({
    radio: ["singleOccurrence", Validators.required]    
  });

  mStep1Event(){
    console.log("maintenanceType", this.maintenanceType);   
    this.maintenanceTypeEvent.emit(this.maintenanceType.value);
  }

}
